import styled from "styled-components";
import { BodyDefault, HeadLine3 } from "../../typography/styled";


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 10px 20px;
  gap: 30px;
  box-sizing: border-box;
  width: 390px;
  max-width: calc(100vw - 32px);
  /* height: 350px; */
  left: 540px;
  top: 305px;
  background: ${({theme}) => theme.palette[10]};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`

export const IconBackground = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 10px;
  width: 100px;
  height: 100px;
  background: linear-gradient(180deg, #FFEBEA 0%, #FFF8F8 100%);
  border-radius: 60px;
  margin-bottom: 14px;
`

export const HeadWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`
export const BodyModal = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  padding:0px 10px;
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
`

export const DeleteTitle = styled(HeadLine3)`
  max-width: 100%;
  text-align: center;
  overflow-wrap: anywhere;
  word-break: break-word;
`

export const GreyText = styled(BodyDefault)`
  color:${({theme}) => theme.palette[800]};
  margin:8px 0px 20px;
  text-align: center;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
`

export const Icon = styled.img`
  &:hover{
    cursor: pointer;
  }
`

export const InstanceWrapper = styled.div`
  background-color: ${({theme}) =>  theme.palette[200]};
  display:flex;
  padding: 5px 8px;
  border-radius: 4px;
  margin:3px;
  align-items: center;
  max-width: 100%;
  box-sizing: border-box;
  min-width: 0;
`

export const Title = styled(BodyDefault)`
  color:${({theme}) => theme.isDark ? theme.palette[800] : theme.palette[900]};
  overflow-wrap: anywhere;
  word-break: break-word;
  min-width: 0;
`

export const StyledIconColored = styled.img`
  margin-right:9px;
  width: 20px;
  height: 20px;
`
